import { useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
//-------------------------------------------
//npm install browser-image-compression
import imageCompression from "browser-image-compression"; // مكتبة ضغط الصور
//---------------------------------------------
import { API } from "../Values";
import { Modal, Button } from "react-bootstrap";

export default function UploadImage(order) {
  const [ShowModal, SetShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [cost, setCost] = useState("");
  const fileInputRef = useRef(null);
  const params = useParams();
  const userinfo = Cookies.get("userinfo")
    ? JSON.parse(Cookies.get("userinfo"))
    : [];
  const navigate = useNavigate();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        // إعدادات الضغط
        const options = {
          maxSizeMB: 0.1, // الحد الأقصى لحجم الصورة (0.1 ميجابايت)
          // maxSizeMB: 0.5, // الحد الأقصى لحجم الصورة (500 ;dg,fhdj)
          maxWidthOrHeight: 420, // الحد الأقصى للطول أو العرض
          useWebWorker: true,
        };

        // ضغط الصورة
        const compressedFile = await imageCompression(file, options);
        setSelectedImage(compressedFile); // تخزين الملف المضغوط
      } catch (error) {
        console.error("خطأ أثناء ضغط الصورة:", error);
      }
    }
  };

  const handleSubmit = async () => {
    if (
      !params.order_id ||
      !params.sender_id ||
      !params.sender_name ||
      !params.receiver_id ||
      !params.receiver_name ||
      !selectedImage
    ) {
      alert("الرجاء تعبئة جميع الحقول واختيار صورة");
      return;
    }

    SetShowModal(true);
    const formData = new FormData();
    formData.append("Action", "uploadImage");
    formData.append("order_id", params.order_id);
    formData.append("sender_id", params.sender_id);
    formData.append("sender_name", params.sender_name);
    formData.append("receiver_id", params.receiver_id);
    formData.append("receiver_name", params.receiver_name);
    formData.append("image", selectedImage);
    formData.append("chat_type", params.chat_type);
    try {
      const response = await axios.post(API.uploadImage, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response);
      SetShowModal(false);
      if (response.data.success) {
        if (params.chat_type == "shkawaDeller") {
          return navigate("../DellerCHatShkawa/" + params.order_id);
        }

        navigate("../DellerCHat/" + params.order_id);
      } else {
        console.error(response.data.error);
        alert(response.data.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  function goback() {
    if (params.chat_type == "shkawaDeller") {
      return navigate("../DellerCHatShkawa/" + params.order_id);
    }
    navigate(-1, { state: { orderId: params.order_id } });
  }

  return (
    <>
      <div
        dir="rtl"
        className="row mt-0 text-center m-auto"
        style={{ maxWidth: "500px" }}
      >
        <div className="col-1 py-1">
          <i
            className="fa-solid fa-chevron-right text-info mt-2 fs-4"
            onClick={() => goback()}
          ></i>
        </div>
        <div className="col-11 py-1 text-center">
          <h4>{"ارفاق صورة"}</h4>
        </div>
        <div className="col-master col-card-alert col-12 mb-4 pt-3">
          <div className="row">
            <div className="col-12 mb-4 text-end">
              <h6>المرفقات</h6>
              <input
                type="file"
                capture="camera"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <button
                type="button"
                className="btn btn-light"
                onClick={handleButtonClick}
              >
                <i className="fa-solid fa-camera fs-4 text-syan mt-2"></i>
                <br />
                {"ارفاق صورة"}
              </button>
            </div>
            {/* <div className="col-12 ">
              <div
                className="m-2 p-2 bg-white"
                style={{ border: "2px solid #f00" }}
              >
                <label htmlFor="">
                  انتبة عند التقاط صورة  تاكد من اخفاء رقم بطاقة الشحن
                  حتى لا تتعرض للاحتيال
                </label>
              </div>
            </div> */}

            <div className="col-12 text-center" style={{ height: "400px" }}>
              {selectedImage && (
                <div
                  className="bg-white p-1 m-auto"
                  style={{
                    marginTop: "20px",
                    width: "100%",
                    height: "300px",
                    border: "2px solid #BFEDF2",
                    borderRadius: "10px",
                    position: "relative",
                  }}
                >
                  <h6
                    className="text-danger mb-1 text-end"
                    onClick={() => setSelectedImage(null)}
                  >
                    x
                  </h6>
                  <img
                    src={URL.createObjectURL(selectedImage)}
                    alt="الصورة المختارة"
                    style={{
                      width: "100%",
                      height: "90%",
                    }}
                  />
                </div>
              )}
            </div>
            <div className="col-12 text-center  mt-4 p-3">
              <br />

              <button
                className="btn btn-green p-2 w-100 fw-bold fs-5"
                onClick={handleSubmit}
              >
                حفظ
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal show={ShowModal} onHide={() => SetShowModal(false)}>
        <Modal.Body>
          <div className="row mt-0 px-0">
            <div className="col-12 text-center">
              <img
                style={{ width: "80px" }}
                src="../../Images/loding2.gif"
                alt=""
              />
              <h4 className="list p-2 my-4">{"جارٍ رفع ومعالجة الصورة"}</h4>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
